import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import TodaysScheduleList from "./TodaysScheduleList";
import * as opexService from "../../services/opexService";
import { getVendorCurrency } from "../../utils/currency";

const statusFor = (daysUntilDue) => {
  if (daysUntilDue < 0) return { label: `Overdue by ${Math.abs(daysUntilDue)}d`, bgColor: "#FEE2E2", textColor: "#DC2626" };
  if (daysUntilDue === 0) return { label: "Due today", bgColor: "#FEE2E2", textColor: "#DC2626" };
  return { label: `Due in ${daysUntilDue}d`, bgColor: "#FEF3C7", textColor: "#D97706" };
};

// Third card next to Today's/Upcoming Booking on the dashboard - surfaces
// Operating Expenses (rent/utilities/office bills) that are overdue or due
// within the next 7 days (see opex.service.js REMINDER_WINDOW_DAYS). Reuses
// TodaysScheduleList for visual consistency instead of a new card component.
// Renders nothing when there's nothing due, so a quiet day doesn't leave an
// empty card taking up space next to the booking widgets.
//
// onHasReminders (optional) is called once loading settles, so the parent
// dashboard can shrink the Today's/Upcoming columns from col-lg-6 to
// col-lg-4 only when this card actually has something to show.
const OpexReminderCard = ({ onHasReminders }) => {
  const navigate = useNavigate();
  const [reminders, setReminders] = useState([]);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    opexService
      .getReminders()
      .then((res) => {
        const data = res?.data || [];
        setReminders(data);
        onHasReminders?.(data.length > 0);
      })
      .catch(() => {
        setReminders([]);
        onHasReminders?.(false);
      })
      .finally(() => setLoaded(true));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!loaded || reminders.length === 0) return null;

  const currency = getVendorCurrency();
  const rows = reminders.map((r) => {
    const status = statusFor(r.days_until_due);
    return {
      id: r.id,
      name: r.title,
      subtitle: `${r.category_name} · ${currency} ${Number(r.amount).toFixed(2)}`,
      timeLabel: new Date(r.next_due_date).toLocaleDateString("en-US", { month: "short", day: "numeric" }),
      statusLabel: status.label,
      statusColors: { bgColor: status.bgColor, textColor: status.textColor },
      onClick: () => navigate("/finance/operating-expenses"),
    };
  });

  return (
    <TodaysScheduleList
      title="Expense Reminders"
      viewAllLabel="View All"
      onViewAll={() => navigate("/finance/operating-expenses")}
      rows={rows}
      emptyLabel="No expenses due"
    />
  );
};

export default OpexReminderCard;
